export default __webpack_public_path__ + "static/media/Group1640.b9a51a5b.svg";